import { useState } from "react";
import { FaPlay, FaPlayCircle, FaStopCircle } from "react-icons/fa";
import { txbb, txpb, txrb, txtb } from "../common_components/text_style_components";

function StartInterviewButton({ startInterview }) {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <div className="w-full">
      {/* End Interview Button with Tooltip */}
      <button
        className=" flex flex-row items-center justify-center
        bg-purple-500 text-white px-6 py-4 rounded-lg
         hover:bg-purple-600 transition relative"
        //onMouseEnter={() => setShowDialog(false)}
        onClick={() => setShowDialog(true)}
      >
         <FaPlayCircle className="text-2xl mx-4" /> &nbsp;
        <span>Start Interview </span>
       
        {/* Tooltip */}
        <span className="absolute -top-8 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-sm px-2 py-1 rounded-lg opacity-0 hover:opacity-100 transition">
          Start the Interview
        </span>
        
      </button>

      {/* Confirmation Dialog */}
      {showDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 text-center ">
          <div className="bg-white text-gray-800 p-6 px-8 
          h-5/6 overflow-auto rounded-lg shadow-lg">
            <div className="mb-4  scroll-auto ">
              
             {<div className="text-2xl px-6 mb-4 text-gray-700 font-mono font-bold">
              <br />
                  Shall We Start  Interview Session? </div>
                }
               
            <div className="flex flex-row mt-4 justify-evenly">
              <button
                className="bg-purple-500 text-white px-6  p-2 rounded-lg hover:bg-purple-600"
                onClick={() => {
                  setShowDialog(false);
                  startInterview(); // Call callback
                }}
              >
                Yes, Start Interview
              </button>
              <button
                className="bg-teal-500 text-white px-6 p-2 rounded-lg hover:bg-teal-600"
                onClick={() => setShowDialog(false)}
              >
                No
              </button>
            </div>

                <br />
                <div className=" px-6 bg-teal-100"> Only {txrb("supported browsers")}  are  {txbb("Microsoft Edge")} and {txbb("Google Crome")}.
                  </div> <br />

                  <div className="  px-6 bg-teal-100"> It works in {txrb("Voice to Text ")}mode. <br />
                  
                  </div> 
                  <div className="text-sm text-gray-500  font-mono leading-6">
                    You will speak, AI interviewer will reply with Text.
                    </div>
                    <br /> 

                  <div className=" px-6 bg-teal-100">
                    You {txrb("won't")} be able to pause the discussion.</div> 
                    <span className="text-sm text-gray-500 font-mono">
                       So, please make sure you have free time for next 75 minutes. </span>
                <br /><br />
                <div className=" px-6 bg-teal-100">
                  {txrb("Do Not")} press back button or refresh page.</div>
                  <span className="text-sm text-gray-500 font-mono"> Else you will loose access to current session and won't be able to get back to it. </span>
                
                <br /><br />
                </div>
            <div className="flex justify-evenly">
              <button
                className="bg-purple-500 text-white px-6  p-2 rounded-lg hover:bg-purple-600"
                onClick={() => {
                  setShowDialog(false);
                  startInterview(); // Call callback
                }}
              >
                Yes, Start Interview
              </button>
              <button
                className="bg-teal-500 text-white px-6 p-2 rounded-lg hover:bg-teal-600"
                onClick={() => setShowDialog(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export {StartInterviewButton};